import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './store/AuthContext'
import { currentSiteSurface, publicSitePreview } from './lib/siteRouting'
import './styles.css'

const PublicSite = lazy(() => import('./features/PublicSite').then(module => ({ default: module.PublicSite })))
const SiteAdmin = lazy(() => import('./features/SiteAdmin').then(module => ({ default: module.SiteAdmin })))
const MemberSite = lazy(() => import('./MemberSite').then(module => ({ default: module.MemberSite })))
const surface = currentSiteSurface()
const legacyAction = window.location.pathname === '/account-action' || new URLSearchParams(window.location.search).has('mode') || /^#\/(?:f\/|reset-password)/.test(window.location.hash)
if (surface !== 'public' || legacyAction) {
  const robots = document.createElement('meta')
  robots.name = 'robots'; robots.content = 'noindex,nofollow'
  document.head.append(robots)
}


if ('serviceWorker' in navigator && import.meta.env.PROD && window.location.protocol !== 'file:' && surface === 'members') {
  window.addEventListener('load', () => { void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {}) })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="app-loading">Loading the Editorial Board…</div>}>
      {legacyAction || surface === 'members' ? <MemberSite /> : surface === 'admin' ? <BrowserRouter><AuthProvider><SiteAdmin /></AuthProvider></BrowserRouter> : <BrowserRouter basename={publicSitePreview() ? '/public' : '/'}><PublicSite /></BrowserRouter>}
    </Suspense>
  </StrictMode>,
)
